<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-02 15:33:54
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-07 11:05:25
-->
<template>
	<el-button v-if="$isKs()" type="text" :disabled="item.disabled" @click="ksCopy(row)">
		<!--  合作招商的商品 ,二级团的商品展示复制口令-->
		<span class="yx-color-primary">{{ isShowCopyCode ? '复制口令' : '复制ID' }}</span>
	</el-button>
	<el-tooltip v-else class="item" :disabled="$isSp()" effect="dark" :content="content" placement="left">
		<el-button type="text" :disabled="item.disabled" @click="dyCopy(row)">
			<span class="yx-color-primary">复制链接</span>
		</el-button>
	</el-tooltip>
</template>
<script>
import { linkStatus, drRoleType } from '@/utils/dataMap';
import mixin from './mixin';
import { mapGetters } from 'vuex';
export default {
	name: 'CopyLinkButton',
	mixins: [mixin],
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
		row: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		...mapGetters(['isDarenPartner']),
		platformId() {
			return +this.row.platform_id;
		},
		isPartnerAuthUrl() {
			if (this.row.product_type != 1) {
				// 托管类型的商品 展示专属链接
				return true;
			}
			return +this.row.source_type === 2;
		},
		isShowCopyCode() {
			//合作招商的商品, 二级团的商品展示复制口令;
			return +this.row.activity_type === 3 || +this.row.product_type === 4;
		},
		drName() {
			return drRoleType.name;
		},
		content() {
			// 保持不变
			return this.isDarenPartner
				? this.isPartnerAuthUrl
					? '专属链接，达人使用该链接带货产生的订单归属为您的业绩。'
					: '该链接非团长商品链接，达人使用该链接(托管商品链接除外)带货产生的订单无法统计到团队业绩。'
				: `非专属链接，达人使用该链接带货产生的订单无法归属到${this.drName}。请前往${this.drName}账号复制专属链接。`;
		},
	},
	methods: {
		async dyCopy(row) {
			const { url_check_status, partner_url } = row;

			// 合作进度场景下需要判断当前链接校验状态
			if (this.item.scene === 'cooperate' && url_check_status && url_check_status === linkStatus.finished) {
				if (!partner_url) return;
				this.exchangeUrl(row);
				return;
			}
			this.dyNormalCopy(row);
		},
	},
};
</script>
